import { ref, computed } from 'vue';
const listOfSnackbars = ref([]);
const snackbarConfig = ref();
const createId = () => {
    return Date.now();
};
const useSnackbar = () => {
    const setSnackbarConfig = (config) => {
        snackbarConfig.value = {
            reverse: config.reverse ?? false,
            duration: config.duration ?? 2000,
            maxSnackbars: config.maxSnackbars ?? 5,
            closeOnClick: config.closeOnClick ?? true,
            pauseOnHover: config.pauseOnHover ?? true
        };
    };
    const activeSnackbars = computed(() => {
        return snackbarConfig.value.reverse ? [...listOfSnackbars.value].reverse() : [...listOfSnackbars.value];
    });
    const addSnackbar = (snackbar) => {
        const duration = (typeof snackbar.duration === 'number' ? snackbar.duration : snackbarConfig.value.duration) ?? 0;
        const item = {
            id: snackbar.id ?? createId(),
            title: snackbar.title,
            text: snackbar.text,
            subText: snackbar.subText,
            type: snackbar.type,
            duration,
            closable: snackbar.closable,
            actionFunction: snackbar.actionFunction,
            actionLabel: snackbar.actionLabel,
            pauseOnHover: snackbar.pauseOnHover ?? snackbarConfig.value.pauseOnHover
        };
        listOfSnackbars.value.push(item);
        // Remove oldest snackbar if maxSnackbars is reached
        if (snackbarConfig.value?.maxSnackbars && activeSnackbars.value.length > snackbarConfig.value.maxSnackbars) {
            const deleteIndex = snackbarConfig.value.reverse ? activeSnackbars.value.length - 1 : 0;
            closeSnackbar(activeSnackbars.value[deleteIndex].id);
        }
    };
    const handlePortalClick = () => {
        if (snackbarConfig.value.maxSnackbars === 1)
            closeAllSnackbars();
    };
    const handleClick = (snackbar) => {
        if (snackbarConfig.value.closeOnClick && !snackbar.closable) {
            closeSnackbar(snackbar.id);
        }
    };
    const handleAction = (snackbar) => {
        if (snackbar.actionFunction) {
            snackbar.actionFunction();
        }
    };
    const closeSnackbar = (id) => {
        if (!id)
            return;
        const snackbar = listOfSnackbars.value.find((snackbar) => snackbar.id === id);
        removeSnackbarFromList(snackbar);
    };
    const removeSnackbarFromList = (snackbar) => {
        if (!snackbar)
            return;
        const index = listOfSnackbars.value.indexOf(snackbar);
        if (index > -1) {
            listOfSnackbars.value.splice(index, 1);
        }
    };
    const closeAllSnackbars = () => {
        activeSnackbars.value.forEach((snackbar) => removeSnackbarFromList(snackbar));
    };
    return { setSnackbarConfig, activeSnackbars, listOfSnackbars, addSnackbar, handlePortalClick, handleClick, handleAction, closeSnackbar, closeAllSnackbars };
};
export default useSnackbar;
